import React from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import { slide as Menu } from 'react-burger-menu'

class Header extends React.Component {
    
    constructor(props){
        super(props);

        this.state = {
            menuOpen: false,
            scrolled: false,
        }
        
    }

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll, { passive: true });
        this.handleScroll();
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    handleScroll = () => {
        const isScrolled = (window.pageYOffset || document.documentElement.scrollTop) > 15;
        if (isScrolled !== this.state.scrolled) {
            this.setState({ scrolled: isScrolled });
        }
    }

    componentWillReceiveProps(nextProps) {
        if (!this.props.location || this.props.location.pathname !== nextProps.location.pathname) {
            this.handleMenuClick();
        }
    }

    handleMenuClick = (event) => {
        this.setState({menuOpen: false});
    }

    isCyclesActive = (match, location) => {
        if (match) return true;
        const path = location && location.pathname ? location.pathname : '';
        return path.startsWith('/cycles') || path.startsWith('/cycle/');
    }

    isAccessoriesActive = (match, location) => {
        if (match) return true;
        const path = location && location.pathname ? location.pathname : '';
        return path.startsWith('/accessories') || path.startsWith('/accessory/');
    }
    
    render(){
        return ( 
            <header className={this.state.scrolled ? "site-nav-bar scrolled" : "site-nav-bar"}>
                
                <nav className="container">
                    <ul className="logo">
                        <li>
                            <NavLink to="/">
                                <img src="../images/logo-lg.png" alt="Alaska Cykler" className="hidden-xs hidden-sm visible-md visible-lg" />
                                <img src="../images/logo-sm.png" alt="Alaska Cykler" className="visible-xs visible-sm hidden-md hidden-lg" />
                            </NavLink>
                        </li>
                    </ul>

                    <ul className="nav desktop">                 
                        <li><NavLink to="/" exact={true}>Hjem</NavLink></li>
                        <li><NavLink to="/cycles" isActive={this.isCyclesActive}>Cykler</NavLink></li>
                        <li><NavLink to="/accessories" isActive={this.isAccessoriesActive}>Tilbehør</NavLink></li>
                        <li><NavLink to="/repairs">Værksted</NavLink></li>
                        <li><NavLink to="/rent-a-cycle">Cykeludlejning</NavLink></li>
                        <li><NavLink to="/about">Om Os</NavLink></li>
                        <li><NavLink to="/contact">Kontakt</NavLink></li>
                    </ul>
                </nav>

                <div className="hidden-lg hidden-md">
                <Menu right isOpen={ this.state.menuOpen } >
                    <ul className="nav mobile">                 
                        <li><NavLink to="/" exact={true}>Hjem</NavLink></li>
                        <li><NavLink to="/cycles" isActive={this.isCyclesActive}>Cykler</NavLink></li>
                        <li><NavLink to="/accessories" isActive={this.isAccessoriesActive}>Tilbehør</NavLink></li>
                        <li><NavLink to="/repairs">Værksted</NavLink></li>
                        <li><NavLink to="/rent-a-cycle">Cykeludlejning</NavLink></li>
                        <li><NavLink to="/about">Om Os</NavLink></li>
                        <li><NavLink to="/contact">Kontakt</NavLink></li>
                    </ul>
                </Menu>
                </div>
            </header>
        )
    }
}

export default withRouter(Header);


// WEBPACK FOOTER //
// ./src/Common/Header.js